import React from 'react';

import { learnJSData } from 'data/javascript/learn';

import DescriptionEntry from 'components/shared/description-entry';

const Example = () => {
  const item = learnJSData?.items.find(
    (item) => item.title === 'Script Example'
  );

  return <DescriptionEntry entry={item} />;
};

export default Example;
